import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDontuse = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.43378 24.0114V21.6019C8.43378 21.5283 8.40807 21.4571 8.36109 21.4005L2.30646 14.1039C2.29108 14.0853 2.27782 14.0652 2.26734 14.0435C1.6624 12.7916 1.98314 10.9588 4.28152 12.0019C4.31499 12.0171 4.34535 12.0377 4.37134 12.0637C4.6754 12.3677 6.71106 14.4032 6.85677 14.5491C7.008 14.7005 6.86881 4.0928 6.85749 3.24769C6.85696 3.20842 6.86362 3.17529 6.87852 3.13896C7.37474 1.92968 9.03719 1.34427 9.97627 3.12699C9.99909 3.17031 10.0109 3.2196 10.0109 3.26857C10.0109 4.57916 10.0109 6.26124 10.0109 7.92552M10.0109 11.7104C10.0109 10.5962 10.0109 9.26662 10.0109 7.92552M10.0109 7.92552C10.0109 7.92552 11.4302 5.87537 12.8495 7.92552M12.8495 7.92552C12.8495 9.40362 12.8495 11.7104 12.8495 11.7104M12.8495 7.92552C13.6246 6.53041 15.4662 6.9637 15.8284 7.87749C15.8409 7.909 15.8459 7.9428 15.8459 7.9767V8.87175M15.8459 11.7104V8.87175M15.8459 8.87175C15.8459 8.87175 17.3728 7.03948 18.9242 8.78364C18.9732 8.83877 19 8.91216 19 8.98594V17.9696C19 18.0021 18.995 18.0343 18.9852 18.0653L17.9109 21.4414C17.9011 21.4723 17.8961 21.5046 17.8961 21.5371V24.0114",
		stroke: "currentColor",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("line", {
		x1: 1.31034,
		y1: 23.2759,
		x2: 22.3103,
		y2: 3.27586,
		stroke: "currentColor",
		strokeWidth: 2
	})]
});
export default SvgDontuse;
